module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Valentino's Love-Child")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('div', {
    staticClass: "chapterBody"
  }, [_c('br'), _c('br'), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Dear Reader,")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Harlequin Presents"), _c('sup', [_vm._v("®")]), _vm._v(" is all about passion, power, seduction, oodles of wealth and abundant glamour. This is the series of the rich and the superrich. Private jets, luxury cars and international settings that range from the wildly exotic to the bright lights of the big city! We want to whisk you away to the far corners of the globe and allow you to escape and indulge in a unique world of unforgettable men and passionate romances. There is only one Harlequin Presents"), _c('sup', [_vm._v("®")]), _vm._v(", available all month long. And we promise you the world….")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("As if this weren’t enough, there’s more! More of what you love…. Two weeks after the Presents"), _c('sup', [_vm._v("®")]), _vm._v(" titles hit the shelves, four Presents"), _c('sup', [_vm._v("®")]), _vm._v(" EXTRA titles join them! Presents"), _c('sup', [_vm._v("®")]), _vm._v(" EXTRA is selected especially for you—your favorite authors and much-loved themes have been handpicked to create exclusive collections for your reading pleasure. Now there’s another excuse to indulge! Midmonth, there’s always a new collection to treasure—you won’t want to miss out.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Harlequin Presents"), _c('sup', [_vm._v("®")]), _vm._v("—still the original and the best!")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Best wishes,")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("The Editors")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f3ef163","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/valentinoslovechild_fm02.vue
// module id = 60
// module chunks = 0